module.exports = __webpack_public_path__ + "media/images/lb/318-4055133c5eb4bd5e8263b2de87c480e8.svg";